import React from 'react';

import cls from './layout.module.scss';
// import Sidebar from 'components/sidebar/sidebar';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className={cls.layout}>
      <main className={cls.container}>
        <div className={cls.content}>{children}</div>
      </main>
    </div>
  );
};

export default Layout;
